import { put, fork, takeLatest, call } from 'redux-saga/effects';
import * as api from '../services/api';
import { load, loaded } from '../ducks/loading';
import * as actions from '../ducks/visitor';
import { toastify } from '../ducks/toast';

function* getVisitor(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/getVisitorsEs', action.payload);


    if (res.status === 'success') {
      yield put(actions.getVisitorSuccess(res.data));
    }
    else {
      yield put(toastify({ type: 'error', msg: res.m }));
    }
    yield put(loaded());
  } catch (error) {
    yield put(loaded());
    yield put(toastify({ type: 'error', msg: 'Something went wrong while doing. Please try again.' }));
  }
}

function* getVisitHistory(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/getVisitHistoryEs', action.payload);

    if (res.status === 'success') {
      yield put(actions.getVisitorHistrSuccess(res.data));
    }
    else {
      yield put(toastify({ type: 'error', msg: res.m }));
    }
    yield put(loaded());
  } catch (error) {
    yield put(loaded());
    yield put(toastify({ type: 'error', msg: 'Something went wrong while doing. Please try again.' }));
  } 
}

export function* watchGetVisitor() {
  yield takeLatest(actions.getVisitor.type, getVisitor);
}
export function* watchGetVisitorHistry() {
  yield takeLatest(actions.getVisitHistr.type, getVisitHistory);
}

export default function* rootSaga() {
  yield fork(watchGetVisitor);
  yield fork(watchGetVisitorHistry);
}
